import { Component, Inject, OnInit } from '@angular/core';
import {
  MAT_LEGACY_SNACK_BAR_DATA as MAT_SNACK_BAR_DATA,
  MatLegacySnackBarRef as MatSnackBarRef
} from '@angular/material/legacy-snack-bar';

export class SnackBarNotifierData {
  message: string;
  showButton: boolean = true;
  header: string = '';
  confirmButtonText: string = 'Confirm';
  confirmButtonColor: string = 'primary';
  showDismissAction: boolean = true;
}

@Component({
  selector: 'sd-snackbar-notifier',
  templateUrl: './snackbar-notifier.component.html',
  styleUrls: ['./snackbar-notifier.component.scss']
})
export class SnackBarNotifierComponent implements OnInit {
  constructor(
    @Inject(MAT_SNACK_BAR_DATA) public data: SnackBarNotifierData,
    public snackBarRef: MatSnackBarRef<SnackBarNotifierComponent>
  ) {}

  ngOnInit() {
    this.data = {
      ...new SnackBarNotifierData(),
      ...this.data
    };
  }
}
